import gsap from "gsap";
import lottie from "lottie-web";

export default {
    /**
     * @param
     * selector: 선택한 요소
     * yPecent: 높이 요소의 위치
     * opacity: 표시 여부
     * duration: 시간
     * xPecent: 가로 요소의 위치
     */
    setAnimation(selector, yPecent, opacity, duration, visibility) {
        //selector .slide~ 클래스를 기준으로 반복 처리 작업 수정
        const el = document.querySelector(selector);
        //console.log(el);
        if (yPecent === "not") {
            gsap.to(el, {
                opacity: opacity === "view" ? 1 : 0,
                duration: duration,
            });
        } else if (yPecent === "up" || yPecent === "down") {
            gsap.to(el, {
                y: yPecent === "up" ? 0 : 200,
                opacity: opacity === "view" ? 1 : 0,
                duration: duration,
                ease: "power2.out"
            });
        } else {
            gsap.to(el, {
                y: yPecent,
                opacity: opacity === "view" ? 1 : 0,
                duration: duration,
                visibility: visibility ? visibility : 'initial',
                ease: "power3.out"
            });
        }
    },
    /**
     * @param
     * selector: 선택한 요소
     * xPercent: 높이 요소의 위치
     * opacity: 표시 여부
     * duration: 시간
     * visibility: 표시 여부?
     */
    setXAnimation(selector, xPercent, opacity, duration, visibility) {
        //selector .slide~ 클래스를 기준으로 반복 처리 작업 수정
        const el = document.querySelector(selector);
        gsap.to(el, {
            x: xPercent,
            opacity: opacity || 1,
            duration: duration || 0.5,
            visibility: visibility || 'initial',
            ease: "power3.out"
        });
    },
    setScaleY(selector, per) {
        const el = document.querySelector(selector);
        gsap.to(el, {
            scaleY: per,
        });
    },
    /**
     * @param
     * selector: 선택한 요소
     * path: 높이 요소의 위치
     * opacity: 표시 여부
     * duration: 시간
     * xPecent: 가로 요소의 위치
     */
    loadLottieSetting(selector, loop, autoPlay, setSpeed, path) {
        return lottie.loadAnimation({
            container: document.querySelector(selector),
            renderer: "svg",
            loop: loop,
            autoplay: autoPlay,
            setSpeed: setSpeed,
            path: path,
        });
    },

    /**
    * @param
    * selector: 선택한 요소
    * path: 높이 요소의 위치
    * opacity: 표시 여부
    * duration: 시간
    * xPecent: 가로 요소의 위치
    */
    loadLottieCanvasSetting(selector, loop, autoPlay, setSpeed, path) {
        return lottie.loadAnimation({
            container: document.querySelector(selector),
            renderer: "canvas",
            loop: loop,
            autoplay: autoPlay,
            setSpeed: setSpeed,
            path: path,
        });
    },

}